<template>
  <span class="text-sm text-gray-500">
    <slot />
  </span>
</template>
